module.exports = __webpack_public_path__ + "img/raf-invitation-cards.4f8b36a.png";